export const nextiasLogo = 'https://cdnstatic.nextias.com/resources/logos/Clip path group-1741069343449.svg';
const madeeasyLogo = 'https://cdnstatic.nextias.com//Group-1741069899954.svg';
export const noImage = 'https://cdnstatic.nextias.com/resources/images/noimage-1741258114309.png';
const testingImage = 'https://cdnstatic.madeeasyprime.com//testingimage-1743408597181.png';
const favNextIas = 'https://cdnstatic.nextias.com/assets/icons/favicon.ico';
const favMadeeasyprime = 'https://www.madeeasy.in/images/capture.ico';
export const madeeasyAdmissionLink = 'https://onlineadmissions.madeeasy.in/Default.aspx';
// export const nextiasAdmissionLink = 'https://onlineadmissions.nextias.com/Default.aspx';
export const nextiasAdmissionLink = 'https://onlineadmissions.nextias.com/login/login.aspx';

export const organizationProperties = {
  // testing exam is mapped on preprod.nextias.com
  testing: {
    orgId: '53155364-5a80-4696-929c-19e75cae1275',
    organizationName: 'Testing',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_NEXTIAS_HOST,
    chatDef: 'NextIAS_appsquadz',
    chatRoomStatus: 'NextIAS_Live',
    logo: testingImage,
  },
  nextias: {
    orgId: '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
    organizationName: 'nextias',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_NEXTIAS_HOST,
    chatDef: 'NextIAS_appsquadz',
    chatRoomStatus: 'NextIAS_Live',
    logo: nextiasLogo,
    favIcon: favNextIas,
  },
  meniit: {
    // TODO
    orgId: 'c2a3acad-54ba-437f-85a1-d0d850cec900',
    organizationName: 'meniit',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_MENIITIAS_HOST,
    logo: nextiasLogo,
    // chatAPiUrl: 'MadeEasy_appsquadz',
  },
  madeeasy: {
    orgId: '9a523aa7-dc66-410a-98bb-8cd66e875f35',
    organizationName: 'madeeasyprime',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_MADEEASY_HOST,
    chatDef: 'MadeEasy_appsquadz',
    chatRoomStatus: 'madeeasyprime_Live',
    logo: madeeasyLogo,
    favIcon: favMadeeasyprime,
  },
  madeeasyprime: {
    orgId: '9a523aa7-dc66-410a-98bb-8cd66e875f35',
    organizationName: 'madeeasyprime',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_MADEEASY_HOST,
    chatDef: 'MadeEasy_appsquadz',
    chatRoomStatus: 'madeeasyprime_Live',
    logo: madeeasyLogo,
    favIcon: favMadeeasyprime,
  },
  dnextias: {
    orgId: '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
    // orgId: '9a523aa7-dc66-410a-98bb-8cd66e875f35',
    organizationName: 'nextias',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_NEXTIAS_HOST,
    chatDef: 'NextIAS_appsquadz',
    chatRoomStatus: 'NextIAS_Live',
    logo: nextiasLogo,
  },
  dme: {
    // orgId: '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
    orgId: '9a523aa7-dc66-410a-98bb-8cd66e875f35',
    organizationName: 'madeeasyprime',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_MADEEASY_HOST,
    chatDef: 'MadeEasy_appsquadz',
    chatRoomStatus: 'madeeasyprime_Live',
    logo: nextiasLogo,
  },
  'localhost:5005': {
    orgId: '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
    organizationName: 'nextias',
    baseApiUrl: process.env.NEXT_PUBLIC_LEGACY_NEXTIAS_HOST,
    chatDef: 'NextIAS_appsquadz',
    logo: nextiasLogo,
  },
};

export const playerQualitiesAvailableVdoCipher = ['Good', 'Better', 'Best'];
export const playerQualitiesAvailable = ['Best', 'Better', 'Good', 'Basic'];

export const getResultFilterData = (isMadeEasy) => ({
  pageFilters: [
    {
      key: 'difficultyLevel',
      name: 'Difficulty',
      options: [
        { id: 'easy', name: 'Easy' },
        { id: 'medium', name: 'Medium' },
        { id: 'hard', name: 'Hard' },
      ],
    },
    {
      key: 'evalStatus',
      name: 'Status',
      options: [
        { id: 'correct', name: 'Correct' },
        { id: 'wrong', name: 'Incorrect' },
        { id: 'skipped', name: 'Unattempted' },
      ],
    },
    ...(isMadeEasy ? [{
      key: 'type',
      name: 'Type',
      options: [
        {
          id: 'single',
          name: 'MCQ',
        },
        {
          id: 'numerical',
          name: 'NAT',
        },
        {
          id: 'multi',
          name: 'MSQ',
          __typename: 'PageFilterTypeOption',
        },
      ],
    }] : []),
  ],
});

export const QUERY_CATEGORIES = [
  'Course Content',
  'Subject Specific Doubt',
  'App Issue',
  'Payments',
  'Others',
];

export const ISSUE_TYPES = [
  'Incorrect Answer / Solution',
  'Question Framing Issues',
  'Technical Errors',
  'Content Mismatch',
  'Outdated or Irrelevant Content',
  'Explanation Quality Issues',
  'Other',
];

export const COURSE_ENTITIES = {
  CLASS_ENTITY: 'ClassEntity',
  LIVE_CLASS_ENTITY: 'LiveClassEntity',
  LIVE_CLASS_VDO_CIPHER_RECORDING_ENTITY: 'LiveClassVdoCipherRecordingEntity',
  LIVE_CLASS_VOD_RECORDING_ENTITY: 'LiveClassVodRecordingEntity',
  LIVE_CLASS_YOUTUBE_RECORDING_ENTITY: 'LiveClassYoutubeRecordingEntity',
  YOUTUBE_CLASS_ENTITY: 'YoutubeClassEntity',
  VOD_CLASS_ENTITY: 'VodClassEntity',
  VDO_CIPHER_CLASS_ENTITY: 'VdoCipherClassEntity',
  HANDOUT_ENTITY: 'HandoutEntity',
  TEST_ENTITY: 'TestEntity',
  LEGACY_TEST_ENTITY: 'LegacyTestEntity',
};
